export default __webpack_public_path__ + "static/media/IMG_2471.6241d520.jpeg";